import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers';
import { router } from './router';
import { RouteFallback } from '@/components/layout/route-fallback';

export const App = () => (
  <Providers>
    <Suspense fallback={<RouteFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  </Providers>
);
